<template>
    <div class="modal" :class="{ 'is-active': opened }">
        <div class="modal-background"></div>
        <div class="modal-content">
            <section class="section is-medium has-text-centered">
                <h1 class="title has-text-light">{{ $t("notification-record-modal.title") }}</h1>
                <h2 v-if="!this.canceled" class="subtitle has-text-light">
                    {{ $t("notification-record-modal.description") }}
                </h2>
                <h2 v-if="this.canceled" class="subtitle has-text-light">
                    {{ $t("notification-record-modal.cancel-description") }}
                </h2>
                <div v-if="!this.canceled" class="buttons are-medium is-centered">
                    <RecordButton @record="toggleRecord"/>
                    <button
                        class="button is-danger mr-3"
                        @click="cancel"
                    >
                        <Icon family="fa" name="fa-video-slash"/>
                        <span>Cancelar</span>
                    </button>
                </div>
        
                <div v-if="this.canceled">
                    <textarea class="textarea is-danger is-focused mt-3" v-model="message" placeholder=""></textarea>
                <div class="buttons are-medium pt-2">
                    <button 
                    class="button is-danger is-fullwidth" 
                    :class="{ 'is-loading': sending }"
                    @click="rejectRecord">{{ $t("notification-record-modal.go-remarks") }}</button>
                </div>
                </div>
                
            </section>
        </div>
    </div>
</template>

<script>
import RecordButton from "@/components/conference/RecordButton";
import { RepositoryFactory } from "@/services/api";

export default {
    name: "notification-record-modal",
    components: {
        RecordButton
    },
    props: {
        roomId: { type: String, required: true },
        display: { type: Boolean, default: false,}
    },
    watch: {
        display(opened) {
            this.opened = opened;
        },
    },
    mounted() {
        this.opened = this.display;
    },
    data() {
        return {
            isRecord: false,
            sending: false,
            message: "",
            opened: false,
            canceled: false
        };
    },
    methods: {
        toggleRecord(isRecord) {
            this.isRecord = !isRecord;
            this.opened = isRecord;
            this.$emit("record", !this.isRecord);
        },
        async rejectRecord() {
            this.sending = true;
            try {
                await RepositoryFactory.record.rejectRecord({
                    roomId: this.roomId,
                    reason: this.message
                });
                this.message = "";
                this.opened = false;
            } catch (error) {
                window.console.log(error);
            }
            this.sending = false;
        },
        cancel() {
            this.canceled = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.flex-centered-content {
    display: flex;
    justify-content: center;
}
</style>